import {Button, CheckIcon, Divider, Layout, Text, TextField} from '@phonectas/unifon-ui-kit';
import React, {useCallback, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import UpsellMessageBox from './UpsellMessageBox';
import {
	FeatureItem,
	FeatureList,
	PriceContainer,
	PriceUnit,
	SubscriptionCard
} from './styled';
import {Price} from '../styled';
import {DialogFooter} from 'common/components/UpsellDialog/styled';
import {VismaUpsellProduct} from 'common/types/store/threeSixtyTypes';
import {convertToKroner} from 'utils/number';
import {isValidPhone} from 'utils/phoneNumber';
import {PRIVATE_SUBSCRIPTIONS_MSG} from '../constants';
import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import {shallow} from 'zustand/shallow';

interface PrivateSubscriptionsProps {
	data: VismaUpsellProduct[] | null;
	addProduct?: (productId: number) => void;
	removeProduct?: (productId: number) => void;
	temp?: number[];
	userPhone?: string;
}

const PrivateSubscriptions: React.FC<PrivateSubscriptionsProps> = ({
	data,
	userPhone,
}) => {
	const [t] = useTranslation();
	const {postUpsellSms} = useThreeSixtyNewStore((state) => ({postUpsellSms: state.postUpsellSms}), shallow);
	const [urlSuccess, setUrlSuccess] = useState(false);
	const [phoneNumber, setPhoneNumber] = useState('');

	const handlePhoneNumberChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			setPhoneNumber(e.target.value);
		},
		[]
	);
	const handleDontAskAgain = useCallback(() => {
		console.log('User opted not to be asked again');
	}, []);

	const handleSendUrl = useCallback(() => {
		postUpsellSms(phoneNumber, () => {
			setUrlSuccess(true);
			setTimeout(() => {
				setUrlSuccess(false);
				setPhoneNumber('');
			}, 3000);
		});
	}, [phoneNumber, postUpsellSms]);

	useEffect(() => {
		setUrlSuccess(false);
		if (userPhone) {
			setPhoneNumber(userPhone);
		}
	}, [userPhone]);

	const canSendUrl = useCallback(() => {
		return isValidPhone(phoneNumber) && phoneNumber.trim().length > 0;
	}, [phoneNumber]);

	return (
		<>
			<Layout style={{padding: '0 16px'}} fullWidth gap="md">
				<UpsellMessageBox
					/* i18next-extract-disable-next-line */
					message={t(PRIVATE_SUBSCRIPTIONS_MSG)}
					status="ok"
				/>

				<>
					{data?.map((sub) => (
						<SubscriptionCard key={sub.id}>
							<Text variant="h3">{sub.product_name}</Text>
							<PriceContainer>
								<Price>{convertToKroner(sub.price, false, true)}</Price>
								<PriceUnit>{t('/mth')}</PriceUnit>
							</PriceContainer>
							<Divider style={{margin: '14px 0 8px 0'}} />
							<FeatureList>
								{sub.sale_pitch?.split('<br>').map((feature: string, index: number) => (
									<FeatureItem key={index}>
										<Text color="secondary" variant="body">{`${feature.trim()}`}</Text>
									</FeatureItem>
								))}
							</FeatureList>
						</SubscriptionCard>
					))}
				</>
			</Layout>
			<Divider style={{marginTop: '16px'}} />
			<DialogFooter>
				<Layout nowrap style={{padding: '16px'}}>
					<Button
						onClick={handleDontAskAgain}
						variant="secondary"
						color="error"
						disabled={true}
					>
						{t('Don\'t ask again')}
					</Button>
				</Layout>
				<Divider vertical />
				<Layout nowrap direction="row" style={{padding: '16px'}} fullWidth>
					<Layout nowrap fullWidth alignItems="center" gap="md" justifyContent="end">
						{urlSuccess && (
							<Layout nowrap alignItems="center" gap="xs">
								<CheckIcon color="success" />
								<Text color="success">{t('URL sent.')}</Text>
							</Layout>
						)}
						<Text color="secondary">{t('SMS to:')}</Text>
						<Layout nowrap style={{width: '210px'}}>
							<TextField value={phoneNumber} fullWidth onChange={handlePhoneNumberChange} />
						</Layout>
					</Layout>
					<div>
						<Button
							onClick={handleSendUrl}
							variant="primary"
							color="success"
							disabled={!canSendUrl()}
						>
							{t('Send URL')}
						</Button>
					</div>
				</Layout>
			</DialogFooter>
		</>
	);
};

export default PrivateSubscriptions;